(function () {
    'use strict';

    function copyUrl(url) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(url);
        }

        return new Promise(function (resolve, reject) {
            var input = document.createElement('textarea');

            input.value = url;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();

            try {
                document.execCommand('copy');
                resolve();
            } catch (error) {
                reject(error);
            } finally {
                input.remove();
            }
        });
    }

    function initShareBar(bar) {
        var shareButton = bar.querySelector('[data-share-url]');
        var copyButton = bar.querySelector('[data-copy-url]');
        var copyLabel = bar.querySelector('[data-copy-label]');
        var status = bar.querySelector('[data-share-status]');
        var url = window.location.href;

        function showCopied() {
            if (copyLabel) {
                copyLabel.textContent = 'Посилання скопійовано';
                window.setTimeout(function () {
                    copyLabel.textContent = 'Копіювати посилання';
                }, 2000);
            }

            if (status) {
                status.textContent = 'Посилання скопійовано';
            }
        }

        if (copyButton) {
            copyButton.addEventListener('click', function () {
                copyUrl(url).then(showCopied);
            });
        }

        if (shareButton) {
            shareButton.addEventListener('click', function () {
                if (navigator.share) {
                    navigator.share({
                        title: document.title,
                        url: url
                    }).catch(function () {});
                    return;
                }

                copyUrl(url).then(showCopied);
            });
        }
    }

    function init() {
        document.querySelectorAll('[data-blog-share]').forEach(initShareBar);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
